// @ts-nocheck
import React from 'react';

interface PDFControlsProps {
  currentPage: number;
  numPages: number | null;
  scale: number;
  totalAnnotations: number;
  currentPageAnnotations: number;
  pdfFingerprint: string;
  isGeneratingFingerprint?: boolean;
  onShowAnnotationsList: () => void;
  onShowImagePanel: () => void;
  onToggleStickyNotesPanel: () => void;
  onToggleCriticalSummaryPanel: () => void;
  onToggleAnalysisReportPanel: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  showImagePanel: boolean;
  showStickyNotesPanel: boolean;
  showCriticalSummaryPanel?: boolean;
  showAnalysisReportPanel?: boolean;
  criticalSummaryCount?: number;
  [key: string]: any;
}

const PDFControls: React.FC<PDFControlsProps> = ({
  currentPage,
  numPages,
  scale,
  totalAnnotations,
  currentPageAnnotations,
  pdfFingerprint,
  onShowAnnotationsList,
  onShowImagePanel,
  onToggleStickyNotesPanel,
  onToggleCriticalSummaryPanel,
  onToggleAnalysisReportPanel,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  showImagePanel,
  showStickyNotesPanel,
  showCriticalSummaryPanel = false,
  showAnalysisReportPanel = false,
  criticalSummaryCount = 0
}) => {
  return (
    <div className="pdf-controls pdf-controls-compact">
      {/* 左侧：页面信息 */}
      <div className="controls-left">
        <span className="page-indicator">
          {currentPage} / {numPages || 1}
        </span>
        <span className="annotation-count">
          {currentPageAnnotations} 标注
        </span>
        {pdfFingerprint && (
          <span className="pdf-id">
            {pdfFingerprint.substring(0, 6)}
          </span>
        )}
      </div>

      {/* 中间：功能按钮（居中） */}
      <div className="controls-center">
        <button
          onClick={onShowAnnotationsList}
          className="control-btn"
        >
          📝 标注 ({totalAnnotations})
        </button>
        <button
          onClick={onToggleStickyNotesPanel}
          className={`control-btn ${showStickyNotesPanel ? 'active' : ''}`}
          title="便利贴管理"
        >
          📌 便签
        </button>
        <button
          onClick={onShowImagePanel}
          className={`control-btn ${showImagePanel ? 'active' : ''}`}
        >
          🖼️ 图表分析
        </button>
        <button
          onClick={onToggleCriticalSummaryPanel}
          className={`control-btn ${showCriticalSummaryPanel ? 'active' : ''}`}
          title="查看所有批判性总结"
        >
          🎯 总结 ({criticalSummaryCount})
        </button>
        <button
          onClick={onToggleAnalysisReportPanel}
          className={`control-btn ${showAnalysisReportPanel ? 'active' : ''}`}
          title="论文分析报告"
        >
          📊 报告
        </button>
      </div>

      {/* 右侧：缩放控制 */}
      <div className="controls-right">
        <div className="zoom-controls">
          <button onClick={onZoomOut} disabled={scale <= 0.5}>−</button>
          <span className="zoom-value">{Math.round(scale * 100)}%</span>
          <button onClick={onZoomIn} disabled={scale >= 3.0}>+</button>
          <button onClick={onResetZoom} className="zoom-reset">重置</button>
        </div>
      </div>
    </div>
  );
};

export default PDFControls;
